import React from "react";
import { Box, Avatar, Typography, IconButton, Paper } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface ChatHeaderProps {
  userName: string;
  userAvatar?: string;
  isOnline: boolean;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  userName,
  userAvatar,
  isOnline,
}) => {
  const getInitials = (name: string): string => {
    const parts = name.trim().split(" ");
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <Paper
      elevation={0}
      sx={{
        px: 3,
        py: 2,
        borderBottom: "1px solid #E0E0E0",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* User info */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar
            src={userAvatar}
            sx={{
              width: 48,
              height: 48,
              backgroundColor: "#178B8E",
              fontWeight: 600,
            }}
          >
            {getInitials(userName)}
          </Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
              {userName}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: isOnline ? "#44b700" : "text.secondary",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              {isOnline && (
                <Box
                  component="span"
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: "#44b700",
                    display: "inline-block",
                  }}
                />
              )}
              {isOnline ? "Online" : "Offline"}
            </Typography>
          </Box>
        </Box>

        {/* Action buttons */}
        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton
            size="medium"
            sx={{
              color: "text.secondary",
              "&:hover": { backgroundColor: "rgba(23, 139, 142, 0.08)" },
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
};

export default ChatHeader;
